module.exports = __webpack_public_path__ + "img/7_101.20ab09f4.png";